// Libs
import React from "react";
import { Card, Form, Button } from "antd";

import logo from "@assets/logo-name.svg";
import microsoftLogo from "@assets/microsoft.svg";
import BackGroundAnimation from "../../components/BackGroundAnimation";
import * as S from "./style";
import { useLogin } from "./useLogin";

function Login() {
  const { onFinishAzure, isAzureLoading } = useLogin();

  return (
    <S.Container>
      <BackGroundAnimation />
      <S.Part>
        <S.ContainerCard>
          <Card
            hoverable
            style={{ borderRadius: "10px" }}
            cover={
              <S.HeaderCard>
                <img src={logo} alt="logo" />
              </S.HeaderCard>
            }
          >
            <S.HeaderWelcome style={{ textAlign: "center" }}>
              <h4 className="mb-2">Bem vindo(a).</h4>
              <span>Clique no botão abaixo e entre com seu usuário Ânima</span>
            </S.HeaderWelcome>

            <Form
              className="mt-2"
              name="login-azure"
              layout="vertical"
              onFinish={onFinishAzure}
            >
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  style={{
                    width: "220px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "5px auto 0 auto",
                    backgroundColor: "#0078D4",
                    borderColor: "#0078D4",
                  }}
                  type="primary"
                  shape="round"
                  size="large"
                  htmlType="submit"
                  loading={isAzureLoading}
                  icon={
                    <img
                      src={microsoftLogo}
                      alt="Microsoft"
                      style={{ width: 18, height: 18, marginRight: 8 }}
                    />
                  }
                >
                  {isAzureLoading ? "Aguarde..." : "Entrar com Microsoft"}
                </Button>
              </Form.Item>
            </Form>

            <S.ButtonsBox>
              <S.Account
                href="https://trocasenha.animaeducacao.com.br"
                target="_blank"
                rel="noopener noreferrer"
              >
                Esqueci minha senha
              </S.Account>
              <S.Account
                href="https://app.pipefy.com/public/form/tR8__Abt"
                target="_blank"
                rel="noopener noreferrer"
              >
                Solicitar acesso
              </S.Account>
            </S.ButtonsBox>
          </Card>
        </S.ContainerCard>
      </S.Part>
    </S.Container>
  );
}

export default Login;
